import { render, staticRenderFns } from "./PricePoint.vue?vue&type=template&id=85d6fcac"
import script from "./PricePoint.vue?vue&type=script&lang=js"
export * from "./PricePoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports